export default __webpack_public_path__ + "static/media/442d64358761739fd3da115db752e1a4.jpg";